import { useState } from "react";
import { Link, NavLink } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/list", label: "全部韩漫" },
  { to: "/shuyuan", label: "书源推荐" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/70 bg-background-50/90 backdrop-blur">
      <nav className="mx-auto flex w-full items-center justify-between px-4 md:px-6 h-16" aria-label="主导航">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap" aria-label="韩漫大全首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-ghost-smile-fill text-lg" />
          </span>
          <span className="heading-font text-xl font-bold text-foreground-950">韩漫大全</span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  isActive
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-2">
          <Link
            to="/shuyuan"
            className="inline-flex items-center gap-1.5 rounded-full bg-secondary-500 px-4 py-2 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-secondary-600"
          >
            <i className="ri-magic-line" />
            免费书源入口
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-background-100"
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
        </button>
      </nav>

      {open && (
        <div className="md:hidden border-t border-background-200/70 bg-background-50 px-4 py-3">
          <div className="flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap ${
                    isActive ? "bg-primary-500 text-background-50" : "text-foreground-800 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/shuyuan"
              onClick={() => setOpen(false)}
              className="mt-1 inline-flex items-center justify-center gap-1.5 rounded-full bg-secondary-500 px-4 py-2 text-sm font-medium text-background-50"
            >
              <i className="ri-magic-line" />
              免费书源入口
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}